/**
 * @desc 红人管理-详情
 */
const URL = "/rantion-kol";
import http, { updateResponse } from "@/http";
export type Response = defs.kol.ResponseDto<defs.kol.CelebrityResponseDto>;
export function request(kolno: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/kol/celebrity/details/${kolno}`, {
      method: "GET",

      ...options,
    }),
  );
}
